// PACKAGES //
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// SOUND //
import useSound from "../../hooks/useSound";
import eating01 from "../../assets/sfx/eating_01.mp3";
import eating02 from "../../assets/sfx/eating_02.mp3";
import eating03 from "../../assets/sfx/eating_03.mp3";

// IMAGES //
import borderPage from "../../assets/border_page.png";
import background from "../../assets/eating_arm_bg.png";
import drawing from "../../assets/eating_arm_drawing.png";
import clothing from "../../assets/eating_arm_clothing.png";
import complexion from "../../assets/eating_arm_complexion.png";
import hair from "../../assets/eating_arm_hair.png";

// STYLES //
import "./chase.css"
import LayeredPixiImage from "../../components/LayeredPixiImage";
import WakeButton from "../../components/WakeButton";
import BrushButton from "../../components/BrushButton";
import Borders from "../../components/Borders";

const babyEatingArmLayers = {
    background: background,
    clothing: clothing,
    complexion: complexion,
    // eyes: eyes,
    hair: hair,
    drawing: drawing
};



export default function Chase({ zombie, setZombie, stopMusic }) {
    const [zombieAge, setZombieAge] = useState(zombie.age)

    useEffect(() => {
        setZombieAge(zombie.age)
      }, [zombie])

    // SOUND //
    const { playRandom, stopSound } = useSound();

    useEffect(() => {
        playRandom(
            [
                eating01,
                eating02,
                eating03
            ],
            1
        );

        return stopSound;
    }, []);
    
    return (
        <div className="game-page chase-page">
            <Borders image={borderPage} scale={0.98} />

            <h1 className="game-title">DEVASTAZIONE!</h1>

            <div className="game-main-grid chase-main">
                <div className="game-image-wrapper">
                    <LayeredPixiImage
                        layers={babyEatingArmLayers}
                        zombie={zombie}
                        layerOptions={{
                            complexion: { alpha: 0.60 }
                        }}
                    />
                </div>

                <section className="game-copy chase-copy">
                    <p>{zombieAge} years pass, as years tend to do. Then tragedy strikes. {zombie.name} is bitten by a rat while playing among the vineyard rows. Strange things begin to happen.  Now the poor child wanders around {zombie.birthplace}, cursed and hungry, searching for the very people who once tucked them into bed at night!</p>

                    <p>And so you face the cruelest choice a parent can make. Will you free {zombie.name} from this curse?</p>

                    <div className="page-actions">
                        <BrushButton
                            className="chase-button"
                            to="/fight"
                            onClick={stopSound}
                        >
                            Face the Curse                    
                        </BrushButton>

                        <WakeButton
                            zombie={zombie}
                            setZombie={setZombie}
                            stopMusic={stopMusic}
                            stopSound={stopSound}
                        />
                    </div>
                </section>
            </div>
        </div>
    )
};